import { Injectable } from '@angular/core';
import { MenuItemNested, MenuSlug } from '@core/const';
import { Store } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { MenuNestedActions } from '../store/actions';
import { StateWithCore } from '../store/core-state';
import { CoreSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class MenuNestedService {
  constructor(private store: Store<StateWithCore>) {}

  loadMenuBySlug(slug: MenuSlug, baseStoreCode: string): void {
    this.store.dispatch(new MenuNestedActions.MenuNestedLoad(slug, baseStoreCode));
  }

  getMenuBySlug(slug: MenuSlug): Observable<StateUtils.LoaderState<MenuItemNested[]>> {
    return this.store.select(CoreSelectors.getMenuNested(slug));
  }

  getMenuBySlugValue(slug: MenuSlug): Observable<MenuItemNested[]> {
    return this.store.select(CoreSelectors.getMenuNestedValue(slug));
  }

  getMenuBySlugLoading(slug: MenuSlug): Observable<boolean> {
    return this.store.select(CoreSelectors.getMenuNestedLoading(slug));
  }

  getMenuBySlugError(slug: MenuSlug): Observable<boolean> {
    return this.store.select(CoreSelectors.getMenuNestedError(slug));
  }

  getMenuBySlugSuccess(slug: MenuSlug): Observable<boolean> {
    return this.store.select(CoreSelectors.getMenuNestedSuccess(slug));
  }

  resetMenuBySlug(slug: MenuSlug): void {
    this.store.dispatch(new MenuNestedActions.MenuNestedReset(slug));
  }

  findNodeById(menuNode: MenuItemNested, id: number | string): MenuItemNested | undefined {
    if (menuNode.id === id) {
      return menuNode;
    }

    if (!menuNode.children || !menuNode.children.length) {
      return undefined;
    }

    let found: MenuItemNested | undefined;
    let i = 0;

    while (!found && i < menuNode.children.length) {
      found = this.findNodeById(menuNode.children[i], id);
      i++;
    }

    return found;
  }
}
